
import { ref, watch, watchEffect, defineComponent } from "vue";
import axios from "axios";
import { useRouter, useRoute } from "vue-router";
import store from "../store";
import Skeleton from "primevue/skeleton";
import InputText from "primevue/inputtext";
import Button from "primevue/button";

const axioCred = axios.create({
  withCredentials: true,
});

export default defineComponent({
  name: "UserOffers",
  components: {
    Skeleton,
    InputText,
    Button
  },
  props: [],
  setup(props) {
    const isLoadingOffers = ref(false);
    const error = ref(null);
    let tickets = ref(store.state.tickets);
    let searchedTickets = ref(store.state.tickets);
    const router = useRouter();
    const route = useRoute();
    let inputValue = ref("");
    const getUserIssues = async () => {
      isLoadingOffers.value = true;
      try {
        const json = await axioCred.get(
          `https://www.biletdv.ru/customer/IBEServices/GetUserIssuesForBackOffice`
        );
        if (json.data) {
          let fetchedOrders = await json.data;

          tickets.value = fetchedOrders.supportRequests.issues;
          searchedTickets.value = fetchedOrders.supportRequests.issues;
          isLoadingOffers.value = false;
        } else {
          console.log("error!");
          isLoadingOffers.value = false;
        }

        isLoadingOffers.value = false;
        console.log(tickets.value);
      } catch (err) {
        if (err.response.status == 401) {
          store.dispatch("auth/logout");
          router.push("/login");
        }
      }
    };
    watch(
      [inputValue, tickets],
      (newValue: any, oldValue: any) => {
        let value: string = inputValue.value;
          if (value) {
            searchedTickets.value = tickets.value.filter(function (issue: any) {              
              return (
                value
                  .toLowerCase()
                  .split(" ")
                  .every((v: any) =>
                    issue.subject.toLowerCase().includes(v)
                  ) ||
                value
                  .toLowerCase()
                  .split(" ")
                  .every((v: any) => issue.id.toString().includes(v))
              
              )})
              console.log(searchedTickets.value);
              
      }
      else if(!inputValue.value){
        searchedTickets.value = tickets.value;
        
      }
      })
    return {
      getUserIssues,
      isLoadingOffers,
      error,
      tickets,
      inputValue,
      searchedTickets

    };
  },
  data() {
    return {
      month: [
        "янв",
        "фев",
        "мар",
        "апр",
        "мая",
        "июн",
        "июл",
        "авг",
        "сен",
        "окт",
        "ноя",
        "дек",
      ],
    };
  },
  methods: {
    
    getCreatedDate(date: any) {
      let created: any = new Date(date);
      let createdDay = created.getDate();
      let createdMonth: any = created.getMonth();
      let createdYear = created.getFullYear();
      let createdHours = function () {
        if (created.getHours() < 10) {
          return "0" + created.getHours();
        } else {
          return created.getHours();
        }
      };
      let createdMinutes = function () {
        if (created.getMinutes() < 10) {
          return "0" + created.getMinutes();
        } else {
          return created.getMinutes();
        }
      };
      return (
        createdDay +
        " " +
        this.month[createdMonth] +
        " " +
        createdYear +
        " " +
        createdHours() +
        ":" +
        createdMinutes()
      );
    },
    getOfferStatus(num: number) {
      if (num == 10) {
        return "Заявка создана";
      } else if (num == 20) {
        return "Заявка в работе";
      } else if (num == 30) {
        return "Заявка обработана";
      } else if (num == 40) {
        return "Сообщение";
      }
    },
    getTicketStatus(num: number) {
      if (num == 1) {
        return "Заявка создана";
      } else if (num == 2) {
        return "Заявка в работе";
      } else if (num == 3) {
        return "Заявка успешно решена";
      } else if (num == 4) {
        return "Требуется обратная связь";
      } else if (num == 5) {
        return "Заявка закрыта";
      } else if (num == 6) {
        return "Отказ по заявке";
      }
    },
  },
  created() {
    this.getUserIssues();
  },
});
